
import NewApiService from "@/utils/new.api.service";

export default {
    index(context) {
        context.commit("setLoading", true);
        return new Promise((resolve, reject) => {
            NewApiService.get("notification", {})
                .then(({ data }) => {
                    context.commit("setList", data);
                    context.commit("setLoading", false);
                    resolve(data);
                })
                .catch(({ response }) => {
                    context.commit("setLoading", false);
                    reject(response)
                });
        });
    },
    unread(context, { page }) {
        context.commit("setBellLoading", true);
        return new Promise((resolve, reject) => {
            NewApiService.get("notification/unread", {
                page
            })
                .then(({ data }) => {
                    context.commit("setUnreadList", data);
                    context.commit("setBellLoading", false);
                    resolve(data);
                })
                .catch(({ response }) => {
                    context.commit("setBellLoading", false);
                    reject(response)
                });
        });
    },
    fetchConfig ({ commit }) {
        commit("setLoading", true);
        return new Promise((resolve, reject) => {
            NewApiService.get("notification/myconfig", {})
                .then(({ data }) => {
                    commit("setConfig", data);
                    commit("setLoading", false);
                    resolve(data);
                })
                .catch(({ response }) => {
                    commit("setLoading", false);
                    reject(response)
                });
        });
    },
    subscribe ({ commit }, params) {
        commit("setLoading", true);
        return new Promise((resolve, reject) => {
            NewApiService.post("notification/subscribe", params)
                .then(({ data }) => {
                    commit("setLoading", false);
                    resolve(data);
                })
                .catch(({ response }) => {
                    commit("setLoading", false);
                    reject(response)
                });
        });
    },
    unsubscribe ({ commit }, params) {
        commit("setLoading", true);
        return new Promise((resolve, reject) => {
            NewApiService.post("notification/unsubscribe", params)
                .then(({ data }) => {
                    commit("setLoading", false);
                    resolve(data);
                })
                .catch(({ response }) => {
                    commit("setLoading", false);
                    reject(response)
                });
        });
    },
    markAsRead ({ commit, dispatch }, notification_id) {
        commit("setLoading", true);
        return new Promise((resolve, reject) => {
            NewApiService.post("notification/mark-as-read/"+notification_id)
                .then(({ data }) => {
                    commit("setLoading", false);
                    dispatch("unread")
                    resolve(data);
                })
                .catch(({ response }) => {
                    commit("setLoading", false);
                    reject(response)
                });
        });
    },
    markAllAsRead ({ commit, dispatch }) {
        commit("setLoading", true);
        return new Promise((resolve, reject) => {
            NewApiService.post("notification/mark-all-as-read")
                .then(({ data }) => {
                    commit("setLoading", false);
                    dispatch("unread")
                    resolve(data);
                })
                .catch(({ response }) => {
                    commit("setLoading", false);
                    reject(response)
                });
        });
    }
}
